import { useCallback } from 'react';
import { useDispatch } from 'umi';

/**
 * 左侧菜单展开/收起控制 Hook
 * 用于在打开侧边栏/Drawer 时收起左侧菜单，关闭时恢复
 */
export function useLeftMenuExpand() {
  const dispatch = useDispatch();

  const collapseMenu = useCallback(() => {
    dispatch({
      type: 'opinionMarketingMenu/toggleMenuExpand',
      payload: { menuExpand: false },
    });
  }, [dispatch]);

  const expandMenu = useCallback(() => {
    dispatch({
      type: 'opinionMarketingMenu/toggleMenuExpand',
      payload: { menuExpand: true },
    });
  }, [dispatch]);

  return { collapseMenu, expandMenu };
}
